(function() {
    'use strict';
    angular
        .module('nasracApp')
        .factory('Forms', Forms);

    Forms.$inject = ['$resource', 'DateUtils'];

    function Forms ($resource, DateUtils) {
        var resourceUrl =  'api/forms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.uploaddate = DateUtils.convertDateTimeFromServer(data.uploaddate);
                    }
                    return data;
                }
            },
            'download': {
                method: 'GET',
                url: 'api/forms/:id/download',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.uploaddate = DateUtils.convertDateTimeFromServer(data.uploaddate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
